import { ReportPeriodGroupingEnum, yupLocalized } from "@ryde/shared";

export interface IFlexGroupingPanelForm {
  groupingParams: string[];
  periodGrouping: ReportPeriodGroupingEnum;
}

export const flexGroupingPanelValidationSchema: Record<
  keyof IFlexGroupingPanelForm,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
> = {
  groupingParams: yupLocalized.array(),
  periodGrouping: yupLocalized.string().required(),
};

export interface IFlexGropingItem {
  value: string;
  label: string;
}
